/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  profile,
  setFormData,
  formData,
  createInput,
  createTextArea,
  // createUploader,
  updateUserManagement,
  getUserManagementList,
  showUserManagement,
  history,
  getRoleList,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const OnSetFormData = () => {
    setFormData({
      title: profile.attributes.title || '',
      description: profile.attributes.description || '',

      start_date: profile.attributes.start_date
        ? `${moment(profile.attributes.start_date).format('YYYY-MM-DD HH:mm')}`
        : '',
      end_date: profile.attributes.end_date
        ? `${moment(profile.attributes.end_date).format('YYYY-MM-DD HH:mm')}`
        : '',
      // photo: profile.attributes.photo || '',
      // first_name: profile.attributes.first_name || '',
      // last_name: profile.attributes.last_name || '',
      // mobile_number: profile.attributes.mobile_number || '',
      // telephone_number: profile.attributes.telephone_number || '',
      // email: profile.attributes.email || '',
      // address: profile.attributes.address || '',
      // role_id: profile.included.roles.id || '',
    });
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        start_date: `${moment(_.get(formData, 'start_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        end_date: `${moment(_.get(formData, 'end_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        photo: formData.photo.cdnUrl,
      };
      updateUserManagement(profile.id, args, ({ data }) => {
        setModal({ isOpen: false });
        getUserManagementList();
        showUserManagement(profile.id);
        history.push(`/important-notification/${_.get(data, 'id')}`);
        // UpdateInfo();
      });
      return;
    }
    const args = {
      ...formData,
      start_date: `${moment(_.get(formData, 'start_date')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      end_date: `${moment(_.get(formData, 'end_date')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
    };
    updateUserManagement(profile.id, args, ({ data }) => {
      getUserManagementList();
      setModal({ isOpen: false });
      showUserManagement(profile.id);
      history.push(`/important-notification/${_.get(data, 'id')}`);
      // UpdateInfo();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {/* <div className="row d-flex justify-content-center">
          <div className="col-4">
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-4 form-group">
            {createUploader(
              { key: 'photo', label: 'Browse' },
              { required: true, crop: '1:1' }
            )}
          </div>
        </div> */}

        <div className="row">
          <div className="col-12 form-grousp">
            {createInput(
              { key: 'title', label: 'Title:' },
              { required: true, placeholder: 'Announcement Title' }
            )}
          </div>
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'description', label: 'Description:' },
              { required: true, placeholder: 'Announcement Description' }
            )}
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label>Start Date:</label>
            <DateInputPicker
              withTime
              className="full-input"
              onChange={handleOnChangeDate('start_date')}
              value={
                `${moment(_.get(formData, 'start_date')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
            />
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label>End Date:</label>
            <DateInputPicker
              withTime
              className="full-input"
              onChange={handleOnChangeDate('end_date')}
              value={
                `${moment(_.get(formData, 'end_date')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  // createUploader: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  // UpdateInfo: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
